__turbopack_context__.v({
  "backgroundLight": "FVUZNG_backgroundLight",
  "backgroundWhite": "FVUZNG_backgroundWhite",
  "captionText": "FVUZNG_captionText",
  "col": "FVUZNG_col",
  "grid1Col": "FVUZNG_grid1Col",
  "grid2Col": "FVUZNG_grid2Col",
  "grid3Col": "FVUZNG_grid3Col",
  "grid4Col": "FVUZNG_grid4Col",
  "innerPadding": "FVUZNG_innerPadding",
  "noGap": "FVUZNG_noGap",
  "responsiveGap": "FVUZNG_responsiveGap",
  "smallGap": "FVUZNG_smallGap",
});
